import React from 'react';
import type { FormattedString } from '../types';
import { buttonClassName, DEFAULT_SIZE, DEFAULT_VARIANT, ButtonStyling } from './styling';

interface IRCButtonProps extends ButtonStyling {
  /** The click handler passed to the button */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;

  /**
   * **NOTE** UX-wise it's often better to not render the button rather than disabling it.
   * If needed, this disables the button functionally and visually.
   */
  disabled?: boolean;

  /** Appends `type="submit"` to the button for use inside forms. */
  isSubmit?: boolean;

  /** The button's text. This is a ReactNode to allow icons and other _subtle_ text styling. */
  children: FormattedString;

  /** title passthrough for the button element, should be used when wrapping an icon or something without visible text */
  title?: string;

  /** useful for when aria attributes need to refer to a button's id */
  id?: string;

  /** aria-disabled passthrough */
  'aria-disabled'?: boolean;
}

export function RCButton({
  variant = DEFAULT_VARIANT,
  size = DEFAULT_SIZE,
  fullWidth,
  inverted,
  children,
  isSubmit,
  onClick,
  disabled,
  title,
  id,
  ...passthroughProps
}: IRCButtonProps) {
  return (
    <button
      className={buttonClassName({ variant, size, fullWidth, inverted })}
      type={isSubmit ? 'submit' : 'button'}
      onClick={onClick}
      disabled={disabled}
      title={title}
      id={id}
      {...passthroughProps}
    >
      {children}
    </button>
  );
}
